import { Redirect, useParams } from "react-router-dom";
import {
  isValidStablesHistoryTab,
  STABLES_HOME_PATH,
} from "./constants";
import { StablesHome } from "./StablesHome";

export const StablesHistorico = () => {
  const { historyTab } = useParams();

  if (!isValidStablesHistoryTab(historyTab) || historyTab === "all") {
    return <Redirect to={STABLES_HOME_PATH} />;
  }

  return <StablesHome historyTab={historyTab} />;
};
